import { WithStyles, withStyles } from '@mui/styles';

import { ClientMessages } from './clientMessages';
import { muiStyles } from './styles';

export interface ClientMessagesProps extends WithStyles<typeof muiStyles> {
}

export default withStyles(muiStyles)(ClientMessages);